
// npm
import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import ImmutablePropTypes from 'immutable-prop-types'

// redux (selectors)
import {getExamData, getSchedulesData} from 'redux/reducers/selectors'
import {getQuestionsData} from 'redux/reducers/exam/content/selectors'
import {getContentData, getGuid, getShowExamInFullScreen} from 'redux/reducers/exam/selectors'
import {getScheduleDataByExamGuid} from 'redux/reducers/schedules/selectors'
import {hasScheduleCommenced} from 'redux/reducers/schedules/schedule/selectors'
import {getResumedQuestionId} from 'redux/reducers/exam/content/complex-selectors'

// redux (actions)
import {setCurrentQuestionId} from './actions'


// CommencedChecker (not connected to store)
// ----------------------------------------------------------------------------

class CommencedChecker extends React.Component
{
	componentDidMount()
	{
		const {schedulesData, examGuid, showExamInFullScreen} = this.props;
		const scheduleData = getScheduleDataByExamGuid(schedulesData)(examGuid);

		if (hasScheduleCommenced(scheduleData)) {
			if (showExamInFullScreen){
				this.props.onFullScreen();
			}
			else{
				this.props.onCommenced();
			}
		}
		else {
			this.props.onNotCommenced();
		}
	}

	render()
	{
		return null;
	}
}

CommencedChecker.propTypes = {
	onCommenced: PropTypes.func.isRequired,
	onNotCommenced: PropTypes.func.isRequired,
	examGuid: PropTypes.string.isRequired,
	schedulesData: ImmutablePropTypes.list.isRequired
}


// CommencedChecker (connected to store)
// ----------------------------------------------------------------------------

const mapStoreToProps = (store) => {
	const contentData = getContentData(getExamData(store));
	const examData = getExamData(store);
    const showExamInFullScreen = getShowExamInFullScreen(examData);
	
	return {
		initialQuestionId: getResumedQuestionId(contentData),
		examGuid: getGuid(examData),
		schedulesData: getSchedulesData(store),
		showExamInFullScreen
	}
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	onCommenced: (initialQuestionId) => () => {
		dispatch(setCurrentQuestionId(initialQuestionId));														// Set up question to resume to!
		ownProps.onCommenced();
	},
	onNotCommenced: (initialQuestionId) => () => {
		dispatch(setCurrentQuestionId(initialQuestionId));														// Set up question to resume to!
		ownProps.onNotCommenced();
	},
	onFullScreen: (initialQuestionId) => () => {
		dispatch(setCurrentQuestionId(initialQuestionId));														// Set up question to resume to!
		ownProps.onFullScreen();
	}		
})

const mergeProps = (storeProps, dispatchProps, ownProps) => ({
	examGuid: storeProps.examGuid,
	schedulesData: storeProps.schedulesData,
	onCommenced: dispatchProps.onCommenced(storeProps.initialQuestionId),
	onNotCommenced: dispatchProps.onNotCommenced(storeProps.initialQuestionId),
	showExamInFullScreen: storeProps.showExamInFullScreen,
	onFullScreen: dispatchProps.onFullScreen(storeProps.initialQuestionId)	
});

const args = [mapStoreToProps, mapDispatchToProps, mergeProps];
CommencedChecker = connect(...args)(CommencedChecker);


// Export
// ----------------------------------------------------------------------------
export {CommencedChecker}